import { HStack, Button, Badge } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCourse } from '../contexts/CourseContext';
import { useCourseConfig } from '../hooks/useCourseConfig';
import { useConsentStatus } from '../hooks/useConsentStatus';
import { usePreferencesStatus } from '../hooks/usePreferencesStatus';

function toLabel(slug: string) {
  if (slug === 'landing') return 'Start';
  if (slug === 'preferences') return 'Preferences';
  if (slug === 'chat') return 'Chat';
  // Title-case fallback
  return slug.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function CourseStepNav() {
  const { currentCourse } = useCourse();
  const config = useCourseConfig();
  const navigate = useNavigate();
  const location = useLocation();
  const { consentGiven, loading } = useConsentStatus();
  const { hasPreferences, loading: loadingPrefs } = usePreferencesStatus();

  const activeSlug = useMemo(() => {
    const path = location.pathname;
    // Prefer dynamic step route
    const match = path.match(/^\/s\/([^/?#]+)/);
    if (match) return match[1];
    if (path.startsWith('/preferences')) return 'preferences';
    if (path.startsWith('/chat')) return 'chat';
    if (path === '/' || path.startsWith('/login')) return '';
    return '';
  }, [location.pathname]);

  if (!currentCourse) return null; // Hide when no course

  return (
    <HStack spacing={2} mb={4} wrap="wrap">
      {config.flow.map((step) => {
        const isActive = step.slug === activeSlug;
        let gated = false;
        if (step.slug === 'preferences') {
          gated = !consentGiven;
        } else if (step.slug === 'activity') {
          gated = !consentGiven;
        } else if (step.slug === 'chat') {
          gated = !consentGiven || !hasPreferences;
        }
        return (
          <Button
            key={step.slug}
            size="sm"
            variant={isActive ? 'solid' : 'outline'}
            colorScheme="purple"
            isDisabled={loading || loadingPrefs || gated}
            onClick={() => navigate(`/s/${step.slug}`)}
          >
            {toLabel(step.slug)}
            {isActive && <Badge ml={2} colorScheme="green">Current</Badge>}
          </Button>
        );
      })}
    </HStack>
  );
}
